import { getAnalytics, logEvent, isSupported } from "firebase/analytics";
import { app } from "../firebase/config";

let analytics = null;
let analyticsReady = false;

// Khởi tạo analytics một cách an toàn
const initializeAnalytics = async () => {
  try {
    if (typeof window !== "undefined") {
      const supported = await isSupported();
      if (supported) {
        analytics = getAnalytics(app);
        analyticsReady = true;
        console.log("Analytics utility initialized successfully");
      } else {
        console.warn("Analytics not supported in this environment");
      }
    }
  } catch (error) {
    console.warn("Failed to initialize analytics utility:", error);
    analyticsReady = false;
  }
};

// Gọi initialization
initializeAnalytics();

// Helper function để kiểm tra analytics có sẵn không
const isAnalyticsReady = () => analyticsReady && analytics;

export const trackButtonClick = (buttonName, additionalParams = {}) => {
  if (isAnalyticsReady()) {
    try {
      logEvent(analytics, "button_click", {
        button_name: buttonName,
        ...additionalParams,
      });
    } catch (error) {
      console.warn("Failed to track button click:", error);
    }
  }
};

export const trackPageView = (pageName, additionalParams = {}) => {
  if (isAnalyticsReady()) {
    try {
      logEvent(analytics, "page_view", {
        page_name: pageName,
        ...additionalParams,
      });
    } catch (error) {
      console.warn("Failed to track page view:", error);
    }
  }
};

export const trackFeatureUsage = (featureName, additionalParams = {}) => {
  if (isAnalyticsReady()) {
    try {
      logEvent(analytics, "feature_use", {
        feature_name: featureName,
        ...additionalParams,
      });
    } catch (error) {
      console.warn("Failed to track feature usage:", error);
    }
  }
};

export const trackVideoView = (videoName, additionalParams = {}) => {
  if (isAnalyticsReady()) {
    try {
      logEvent(analytics, "video_view", {
        video_name: videoName,
        ...additionalParams,
      });
    } catch (error) {
      console.warn("Failed to track video view:", error);
    }
  }
};

export const trackContactClick = (contactType, additionalParams = {}) => {
  if (isAnalyticsReady()) {
    try {
      logEvent(analytics, "contact_click", {
        contact_type: contactType,
        ...additionalParams,
      });
    } catch (error) {
      console.warn("Failed to track contact click:", error);
    }
  }
};
